<template>
  <vx-card title="Tax Setting">
    <ASpin :spinning="loading" :indicator="indicator">
      <a-form :form="form" @submit.prevent="handleTax">
        <div class="flex gap-4">
          <a-form-item label="Rate">
            <a-input-number
              v-decorator="['tax.rate',{ rules: [{ required: true, message: 'Please enter Rate field.' }] }]"
              :min="1"
              :max="99"
              autocomplete="none"
            />
          </a-form-item>
          <a-form-item label="Type">
            <a-input
              v-decorator="['tax.type',{ rules: [{ required: true, message: 'Please enter Type field.' }] }]"
              autocomplete="none"
            />
          </a-form-item>
        </div>
        <a-divider />
<!--        <a-button type="primary" html-type="submit" class="mt-2" style="border-radius: 3px !important;">Save</a-button>-->
      </a-form>

      <a-form :form="invoiceForm">
        <h4 class="pt-2">E-Invoicing Information</h4>
        <div class="flex gap-4 mt-8">
          <a-form-item label="TIN" help="Tax identification number">
            <a-input
              v-decorator="['code']"
              autocomplete="none"
            />
          </a-form-item>
          <a-form-item label="NRIC ID Number">
            <a-input
              v-decorator="['id_value']"
              autocomplete="none"
            />
          </a-form-item>
          <a-form-item label="BRN">
            <a-input
              v-decorator="['brn']"
              autocomplete="none"
              placeholder="Business Registration Number"
            />
          </a-form-item>
          <a-form-item label="SST Registration Number">
            <a-input
              v-decorator="['sst_registeration_number']"
              autocomplete="none"
              placeholder="SST Registration Number"
            />
          </a-form-item>
          <a-form-item label="MSIC Code" help="Malaysia Standard Industrial Classification">
            <a-input
              v-decorator="['msic_code']"
              autocomplete="none"
            />
          </a-form-item>
        </div>
      </a-form>

      <a-button type="primary" class="mt-2" @click="handleFormsSubmit" style="border-radius: 3px !important;">Save</a-button>
    </ASpin>
  </vx-card>
</template>

<script>
import mixin from '@/views/mixin/mixin'
import axios from '@/axios'

export default {
  name: "TaxSetting",
  mixins: [mixin],
  data(){
    return {
      loading: false,
      taxes: null,
      invoiceForm: this.$form.createForm(this, {name: 'coordinated'}),
    }
  },
  methods: {
    handleTax() {
      this.form.validateFields(async (err,values) => {
        if (!err) {
          try {
            this.loading = true
            await axios.put('/setting/firm/',values)
            this.$notification['success']({
              message: 'Success',
              description: `Tax successfully changed.`,
            });
          } catch (e) {
            this.$notification['error']({
              message: 'failed',
              description: `Tax Setting failed.`,
            });
            throw e
          } finally {
            this.loading = false
          }
        }
      })
    },
    async getTaxSetting() {
      try {
        this.loading = true
        const {data} = await axios.get('/setting/firm/')
        if (data && data.setting) {
          this.form.setFieldsValue(data.setting)
          this.invoiceForm.setFieldsValue(data.setting.accounts.tin[data.setting.accounts.tin.length - 1])
        }
      } catch (e) {
        this.$message.error('Server error')
        throw e
      } finally {
        this.loading = false
      }
    },

    async handleFormsSubmit() {
      this.handleTax()

      // Handling invoice form submit.
      this.invoiceForm.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loading = true
            const { data } = await axios.post('/dictionary/tin-code/', { type: 'NRIC', ...values })
            this.$notification['success']({
              message: 'Success',
              description: data.message,
            });
          } catch (e) {
            this.$notification['error']({
              message: 'failed',
              description: `E-Invoice information failed.`,
            });
            throw e
          } finally {
            this.loading = false
          }
        }
      })
   },
  },

  mounted() {
    this.getTaxSetting()
  }
}
</script>

<style scoped>

</style>
